export const sortByField = (fieldName: string, desc = false) => {
  return (a: any, b: any) => {
    a = a[fieldName] || null;
    b = b[fieldName] || null;

    if (a > b) {
      return desc ? -1 : 1;
    }
    if (a < b) {
      return desc ? 1 : -1;
    }
    return 0;
  };
};

export default sortByField;
